require('./site/bootstrap')
import Swiper, { Pagination, Lazy, Autoplay, EffectFade } from 'swiper';
import { Fancybox } from "@fancyapps/ui"
Swiper.use([ Pagination, Lazy, Autoplay, EffectFade ]);

import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/modal';

$(function () {
	const rootEl = $('html')
	const scrollEl = $('html,body')
	const appEl = $('#app')
	const windowEl = $(window)


	/*/
	 *  Tooltip
	/*/
		// $('[data-toggle=tooltip]').tooltip({
		// 	placement: 'bottom',
		// 	// container: document.querySelector('.header [data-toggle=tooltip]').parentElement
		// })


	/*/
	 *  Header fixed
	/*/
		var observerCount = 0
        var observerTargetEl = document.querySelector('html')
		var observerEl = document.querySelector('#index')
        var observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting === false) {
                observerTargetEl.classList.add('is--nav_fixed')
            } else {
                observerTargetEl.classList.remove('is--nav_fixed')
            }
        }, { threshold: [0] });
        observer.observe(observerEl);

        $(window).scroll(function () {
			let position = $(this).scrollTop()

			if (position > observerEl.offsetHeight) {
				rootEl.addClass('is--scrolled').removeClass('is--nav')
				
				if (position <= observerCount) {
					rootEl.addClass('is--scrolled_up')
				} else {
					rootEl.removeClass('is--scrolled_up')
				}
				observerCount = position		
			} else {
				rootEl.removeClass('is--scrolled').removeClass('is--scrolled_up')
			}
		})


    /*/
	 *  Video presentation
	/*/
		var observerElVideo = document.querySelector('#js--video')
		
		if (observerElVideo) {
			var observerVideo = new IntersectionObserver(function(entries) {
	            if (entries[0].isIntersecting === true) {
	                observerElVideo.play()
	            } else {
	                observerElVideo.pause()
	                observerElVideo.currentTime = 0;
	            }
	        }, { threshold: [0] });
	        observerVideo.observe(observerElVideo);
		}


	/*/
	 *  Navbar visibility
	/*/
		$('[ve-nav]').click(() => {
			rootEl.toggleClass('is--nav')
		})

		$(document).keyup(function(e) {
			 if (rootEl.hasClass('is--nav') && e.keyCode == 27) {
				rootEl.removeClass('is--nav')
			}
		})


	/*/
	 *  Navbar anchor
	/*/
		$('[ve-anchor]').click(function(a){
			let anchorOffset = 0
			let anchorRef = $(this).attr('ve-anchor')
			
			if (appEl.hasClass('has--scroll-navigation') || $(this).data('contact')) {
				a.preventDefault()

				if (windowEl.innerWidth() <= 767 && anchorRef !== '#app') {
					anchorOffset = $('.header').outerHeight() - 1
				}

				scrollEl.animate({
					scrollTop: $(anchorRef).offset().top - (anchorOffset)
				}, {
					duration: 1000,
					complete: function() {
						rootEl.removeClass('is--scrolled_up')
					}
				});

				rootEl.removeClass('is--nav')
			}
		})

		$('[ve-top]').click(function(a){
			a.preventDefault()
			let anchorRef = $(this).attr('ve-top')

			scrollEl.animate({
				scrollTop: $(anchorRef).offset().top
			}, {
				duration: 1000,
				complete: function() {
					rootEl.removeClass('is--scrolled_up')
				}
			});

			rootEl.removeClass('is--nav')
		})

		$('[ve-anchor-load]').click(function(a) {
			localStorage.setItem('scroll-load', '#content')
		})

		$(window).on('load', function() {
			const activeScroll = localStorage.getItem('scroll-load')

			if (activeScroll) {
				scrollEl.animate({
					scrollTop: $('#content').offset().top
				}, {
					duration: 500,
					complete: function() {
						rootEl.removeClass('is--scrolled_up')
					}
				});

				localStorage.removeItem('scroll-load')
			}
		})

	
	/*/
	 *  Swiper
	/*/
		let swiperSlider = new Swiper('[ve-slider]', {
			loop: true,
			speed: 1000, 
			slidesPerView: 1,
			autoHeight: false,
			observer: true,
			watchOverflow: true,
			threshold: 5,
			effect: 'fade',
			fadeEffect: {
				crossFade: false
			},
			autoplay: {
				delay: 7000,
				disableOnInteraction: true
			},
			lazy: {},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		})

})

/*/
 * Form validation
/*/
	window.addEventListener('load', _ => {
		'use strict'

		const forms = document.querySelectorAll('.needs-validation')
		Array.from(forms).forEach(function (form) {
			form.addEventListener('submit', function (event) {
				const button = this.querySelector('[type=submit]')
				const formReturnSuccess = form.dataset.success
				const formReturnError = form.dataset.error
				const formSend = form.dataset.send
				const formSending = form.dataset.sending

				if (!form.checkValidity()) {
					event.preventDefault()
					event.stopPropagation()

					const invalid = this.querySelector(':invalid')
					invalid.focus()
					// invalid.scrollIntoView({
					// 	behavior: 'smooth',
					// 	block: 'center',
					// 	inline: 'center'
					// })
					// setTimeout(() => {
					// 	invalid.focus()
					// }, 750);
				} else {
					event.preventDefault()

					button.disabled = true
					button.querySelector('span').innerHTML = formSending

					const data = new FormData(this)
					const options = {
						headers: { 'Content-Type': 'multipart/form-data' }
					}

					window.axios.post(this.action, data, options)
						.then(_ => {
							form.reset()
							form.classList.remove('was-validated')

							siteAlert({
								text: formReturnSuccess,
								class: 'alert--i_success',
								seconds: 12000
							})
						}).catch(err => {
							console.error(err)
							if (err.response.status === 400) {
								siteAlert({
									text: err.response.data.errors.recaptcha,
									class: 'alert--i_error',
									seconds: 7000
								})
			
								return;
							}
							
							siteAlert({
								text: formReturnError,
								class: 'alert--i_error',
								seconds: 7000
							})
						}).finally(_ => {
							button.disabled = false
							button.querySelector('span').innerHTML = formSend
						})
				}

				form.classList.add('was-validated')
			}, false)
		})
	})

/*/
 * Alert
/*/
	window.siteAlert = function (params) {
		params = {
			text: params.text ? params.text : '',
			class: params.class ? params.class : 'alert--i_success',
			seconds: params.seconds ? params.seconds : 6000,
		}

		const alert = document.createElement('div')
		alert.classList.add('alert--i', params.class)
		alert.innerHTML = params.text

		document.querySelector('#app').appendChild(alert);

		setTimeout(function () { alert.classList.add('is--visible') }, 500)
		setTimeout(function () { alert.classList.remove('is--visible') }, params.seconds)
		setTimeout(function () { alert.remove() }, params.seconds + 500)

		alert.addEventListener('click', function () {
			this.classList.remove('is--visible')
			setTimeout(function () { alert.remove() }, 500)
		})
	}


/*
 * LGPD Popup
*/
	window.addEventListener('load', _ => {
		const siteLGPD = document.querySelector('.lgpd')

		if (siteLGPD) {
			const siteLGPDCheck = localStorage.getItem('lgpd_terms_accepted')
			const siteLGPDDismiss = siteLGPD.querySelector('[ve-lgpd]')

			setTimeout(() => {
				if (!siteLGPDCheck) {
					siteLGPD.classList.add('is--visible')
					siteLGPDDismiss.focus()
				} else {
					siteLGPD.remove();
				}
			}, 3000)

			siteLGPDDismiss.addEventListener('click', _ => {
				siteLGPD.classList.remove('is--visible')
				localStorage.setItem('lgpd_terms_accepted', true)

				setTimeout(function () {
					siteLGPD.remove()
				}, 1000)
			})
		}
	})


/*/
 *  Sort categories
/*/
	const categoriesList = document.querySelector('.news--categories .dropdown-menu')

	function sortCategoriesList() {	
		Array.from(categoriesList.getElementsByTagName('li'))
			.sort((a, b) => a.textContent.localeCompare(b.textContent))
			.forEach(li => categoriesList.appendChild(li));
	}
	
	if (categoriesList) sortCategoriesList()


/*/
	*  Article buttons
/*/
	const articleButtons = document.querySelectorAll('.news--body .btn')

	if (articleButtons.length > 0) {
		articleButtons.forEach(e => {
			const label = e.textContent

			e.innerHTML = `
				<span>${label}</span>
				<svg class="icon icon--arrow"><use xlink:href="#ic-arrow"></use></svg>
			`
		})
	}


/*/
*  Privacy policy buttons
/*/
	const privacyPolicyButtons = document.querySelectorAll('.privacy--content .btn')

	if (privacyPolicyButtons.length > 0) {
		privacyPolicyButtons.forEach(e => {
			const label = e.textContent

			e.innerHTML = `
				<span>${label}</span>
				<svg class="icon icon--arrow"><use xlink:href="#ic-arrow"></use></svg>
			`
		})
	}


/*/
 *  Fancybox
/*/
	const siteFancyboxLangs = {
		pt: {
			CLOSE: "Fechar",
			NEXT: "Próxima",
			PREV: "Anterior",
			MODAL: "Você pode fechar essa modal pressionando ESC",
			ERROR: "Algo deu errado. Tente Novamente.",
			IMAGE_ERROR: "Imagem não encontrada",
			ELEMENT_NOT_FOUND: "Elemento HTML não encontrado",
			AJAX_NOT_FOUND: "Erro ao carregar AJAX : Não encontrado",
			AJAX_FORBIDDEN: "Erro ao carregar AJAX : Acesso restrito",
			IFRAME_ERROR: "Erro ao carregar página",
		},
		en: {
			CLOSE: "Close",
			NEXT: "Next",
			PREV: "Previous",
			MODAL: "You can close this modal content with the ESC key",
			ERROR: "Something Went Wrong, Please Try Again Later",
			IMAGE_ERROR: "Image Not Found",
			ELEMENT_NOT_FOUND: "HTML Element Not Found",
			AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
			AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
			IFRAME_ERROR: "Error Loading Page",
			TOGGLE_ZOOM: "Toggle zoom level",
			TOGGLE_THUMBS: "Toggle thumbnails",
			TOGGLE_SLIDESHOW: "Toggle slideshow",
			TOGGLE_FULLSCREEN: "Toggle full-screen mode",
			DOWNLOAD: "Download",
		},
		es: {
			CLOSE: "Cerrar",
			NEXT: "Siguiente",
			PREV: "Anterior",
			MODAL: "Puedes cerrar esta ventana con la tecla ESC",
			ERROR: "Algo salió mal, inténtalo de nuevo más tarde",
			IMAGE_ERROR: "Imagen no encontrada",
			ELEMENT_NOT_FOUND: "Elemento HTML no encontrado",
			AJAX_NOT_FOUND: "Error al cargar el AJAX : No encontrado",
			AJAX_FORBIDDEN: "Error al cargar el AJAX : Prohibido",
			IFRAME_ERROR: "Error al cargar la página",
			TOGGLE_ZOOM: "Cambiar el nivel de zoom",
			TOGGLE_THUMBS: "Cambiar a miniaturas",
			TOGGLE_SLIDESHOW: "Cambiar a modo presentación",
			TOGGLE_FULLSCREEN: "Cambiar a modo pantalla completa",
			DOWNLOAD: "Descargar",
		}
	}

	let siteFancyboxLang = siteFancyboxLangs.pt
	const siteLang = document.documentElement.lang.split('-')[0]

	if (siteLang == 'pt') siteFancyboxLang = siteFancyboxLangs.pt
	if (siteLang == 'en') siteFancyboxLang = siteFancyboxLangs.en
	if (siteLang == 'es') siteFancyboxLang = siteFancyboxLangs.es

	Fancybox.defaults.l10n = siteFancyboxLang

	Fancybox.bind('[data-fancybox]', {
		infinite: false,
		Carousel: {
			Navigation: {
				prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M11 5l-7 7 7 7"/><path d="M4 12h16"/></svg>',
				nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M4 12h16"/><path d="M13 5l7 7-7 7"/></svg>',
			},
		},
		Toolbar: {
			display: [
				"counter",
				"slideshow",
				"thumbs",
				"close",
			],
			items: {
				counter: {
					type: "div",
					class: "fancybox__counter",
					html: '<span data-fancybox-index=""></span>&nbsp;/&nbsp;<span data-fancybox-count=""></span>',
					tabindex: -1,
					position: "left",
				},
				slideshow: {
					type: "button",
					class: "fancybox__button--slideshow",
					label: "TOGGLE_SLIDESHOW",
					html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><g><path d="M6 4v16"/><path d="M20 12L6 20"/><path d="M20 12L6 4"/></g><g><path d="M7 4v15M17 4v15"/></g></svg>`,
					click: function (event) {
						event.preventDefault();
						this.Slideshow.toggle();
					},
				},
				zoom: {
					type: "button",
					class: "fancybox__button--zoom",
					label: "TOGGLE_ZOOM",
					html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><circle cx="10" cy="10" r="7"></circle><path d="M16 16 L21 21"></svg>',
					click: function (event) {
						event.preventDefault();
						const panzoom = this.fancybox.getSlide().Panzoom;
						if (panzoom) {
							panzoom.toggleZoom();
						}
					},
				},
				thumbs: {
					type: "button",
					label: "TOGGLE_THUMBS",
					class: "fancybox__button--thumbs",
					html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><circle cx="4" cy="4" r="1" /><circle cx="12" cy="4" r="1" transform="rotate(90 12 4)"/><circle cx="20" cy="4" r="1" transform="rotate(90 20 4)"/><circle cx="4" cy="12" r="1" transform="rotate(90 4 12)"/><circle cx="12" cy="12" r="1" transform="rotate(90 12 12)"/><circle cx="20" cy="12" r="1" transform="rotate(90 20 12)"/><circle cx="4" cy="20" r="1" transform="rotate(90 4 20)"/><circle cx="12" cy="20" r="1" transform="rotate(90 12 20)"/><circle cx="20" cy="20" r="1" transform="rotate(90 20 20)"/></svg>',
					click: function (event) {
						event.stopPropagation();
						const thumbs = this.fancybox.plugins.Thumbs;
						if (thumbs) {
							thumbs.toggle();
						}
					},
				},
				close: {
					type: "button",
					label: "CLOSE",
					class: "fancybox__button--close",
					html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"></path></svg>',
					tabindex: 1,
					click: function (event) {
						event.stopPropagation();
						event.preventDefault();
						this.fancybox.close();
					},
				},
			}
		},
		Thumbs: {
			autoStart: true,
		},
		Hash: false,
	})